import { render, staticRenderFns } from "./WeblinkDisplay.vue?vue&type=template&id=49f28028"
import script from "./WeblinkDisplay.vue?vue&type=script&lang=js"
export * from "./WeblinkDisplay.vue?vue&type=script&lang=js"
import style0 from "./WeblinkDisplay.vue?vue&type=style&index=0&id=49f28028&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports